import * as React from 'react';
import * as classes from './chip.scss';

export const Chip = (props: { value: string | number; handleRemove: Function; static?: boolean }) => (
  <div className={[classes.chip, 'row', 'between-xs', 'middle-xs'].join(' ')}>
    <div>{props.value}</div>
    {!props.static && <i onClick={() => props.handleRemove(props.value)} className="fas fa-times ml-10" />}
  </div>
);



// WEBPACK FOOTER //
// ./src/common/components/chip/chip.component.tsx